export enum ContentType {
  NoActiveCollection = 'NoActiveCollection',
  SelectExperience = 'SelectExperience',
  ShowOffers = 'ShowOffers',
  NoResults = 'NoResults',
}
